module.exports = __webpack_public_path__ + "img/App_Store.9673f41f.svg";